import male01 from '../assets/portraits/male_01.png'
import male02 from '../assets/portraits/male_02.png'
import male04 from '../assets/portraits/male_04.png'
import male05 from '../assets/portraits/male_05.png'
import male06 from '../assets/portraits/male_06.png'
import female01 from '../assets/portraits/female_01.png'
import female02 from '../assets/portraits/female_02.png'
import female03 from '../assets/portraits/female_03.png'
import dog from '../assets/portraits/dog.png'
import type { SurvivorGender } from './types'

export type PortraitKey =
  | 'male_01' | 'male_02' | 'male_04' | 'male_05' | 'male_06'
  | 'female_01' | 'female_02' | 'female_03'
  | 'dog'

export const PORTRAIT_SRCS: Record<PortraitKey, string> = {
  male_01: male01,
  male_02: male02,
  male_04: male04,
  male_05: male05,
  male_06: male06,
  female_01: female01,
  female_02: female02,
  female_03: female03,
  dog,
}

export const PORTRAITS_BY_GENDER: Record<SurvivorGender, PortraitKey[]> = {
  male: ['male_01', 'male_02', 'male_04', 'male_05', 'male_06'],
  female: ['female_01', 'female_02', 'female_03'],
  nonbinary: ['male_01', 'male_02', 'male_04', 'male_05', 'male_06', 'female_01', 'female_02', 'female_03'],
  unspecified: ['male_01', 'male_02', 'male_04', 'male_05', 'male_06', 'female_01', 'female_02', 'female_03'],
}

export function getPortraitSrc(key: string | undefined): string | null {
  if (!key) return null
  return PORTRAIT_SRCS[key as PortraitKey] ?? null
}
